import { Grid, makeStyles, Typography } from "@material-ui/core";

import { COLORS } from "../../../../theme/colors";
import { UnrealizedTrading } from "./UnrealizedTrading";
import { UnrealizedNewPowerAssets } from "./UnrealizedNewPowerAssets";

const useStyles = makeStyles((theme) => ({
  titleContainer: {
    marginTop: theme.spacing(3.75),
    marginBottom: theme.spacing(2.75),
  },
  subTitle: {
    color: COLORS.darks[0][50],
    fontStyle: "italic",
  },
}));

export const PortfolioPowerRevenueTab = () => {
  const classes = useStyles();

  return (
    <>
      <Grid className={classes.titleContainer} container alignItems="center">
        <Typography variant="h4">Sensitivity Analysis - </Typography>
        <Typography className={classes.subTitle} style={{ marginLeft: 4 }}>
          Drag or Insert new parameters to view potential revenue changes
        </Typography>
      </Grid>

      <UnrealizedTrading />

      <UnrealizedNewPowerAssets />
    </>
  );
};
